<template>
  <div class="select-coupon-wrap" v-show="show">
    <div class="mask"></div>
    <div class="content-wrap">
      <div class="title">11.11大额券</div>
      <div class="content">
        <div class="coupon-item" v-if="data && data.length" v-for="item in data" @click="getCoupon(item.id)">
          <img :src="item.imgUrl" />
        </div> 
      </div>
      <div class="btn-wrap">
        <div class="btn" @click="close">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'show'],

  methods: {
    close () {
      this.$emit('complete', null)
    },

    getCoupon (id) {
      this.$emit('select', id)
    }
  }
}
</script>

<style lang="stylus">
@import '../../../common/styl/global.styl'
.select-coupon-wrap
  position fixed
  z-index 2000
  top 0
  left 0
  bottom 0
  right 0
  .mask
    position absolute
    top 0
    left 0
    bottom 0
    right 0
    background #000000
    opacity 0.6
.content-wrap
  position fixed
  bottom 0
  left 0
  width rem(375)
  height rem(500)
  background #ffffff
  .title
    margin rem(21) rem(15) 0
    padding-bottom rem(15)
    font-size rem(16)
    font-weight bold
    color #000
    border-bottom solid rem(1) #e1e1e1
  .content
    margin-top rem(15)
    padding 0 rem(20)
    max-height rem(365)
    overflow-y scroll
    .coupon-item
      width rem(335)
      margin-bottom rem(35)
      background #f00
      img 
        position relative
        width 100%
        height auto
  .btn-wrap
    position fixed
    bottom 0
    left 0
    width rem(375)
    height rem(63)
    border-top solid rem(1) #e1e1e1
    background #ffffff
    .btn
      position absolute
      top 50%
      left 50%
      width rem(355)
      height rem(44)
      transform translate(-50%, -50%)
      border-radius rem(2)
      line-height rem(44)
      font-size rem(16)
      text-align center
      background #000
      color #ffffff
</style>


// WEBPACK FOOTER //
// index.vue?60d1e777